import { useCallback } from "react";
import { Button, Col1, Form, Input, TextInput } from "../lib";
import { useLogin, useServerForm } from "../services";
import { Callout } from "./callout";

const initialValues = {
  otp: "",
};

type Props = {
  email: string | null;
  emailVerified: boolean;
  onSuccess?: (token: string) => void;
  phone: string;
};

export function LoginOtpForm({
  email,
  emailVerified,
  onSuccess,
  phone,
}: Props) {
  // Data
  const [login, isLoading, error] = useLogin();

  // Vars
  const { values, setValue } = useServerForm(initialValues, error);

  const isThailand = phone.startsWith("+66");

  let title: string | null = null;
  let message: string | null = null;

  if (email && emailVerified) {
    title = isThailand ? `Check your phone and email` : `Check your email`;
    message = isThailand
      ? `We've sent a 4-digit OTP to your email ${email} and your phone ${phone}`
      : `We've sent a 4-digit OTP to your email ${email}|Please check spam/junk folder if you don't see it in your inbox.`;
  } else if (email) {
    title = isThailand ? `Check your phone` : `OTP not sent`;
    message = isThailand
      ? `We've sent a 4-digit OTP to your phone ${phone}|Not receiving the OTP? Please send an email from ${email} to verify@smooci.com to get your OTP.`
      : `We could not send OTP to your phone ${phone}|Please send an email from ${email} to verify@smooci.com to get your OTP`;
  } else {
    title = isThailand ? `Check your phone` : `OTP not sent`;
    message = isThailand
      ? `We've sent a 4-digit OTP to your phone ${phone}.`
      : `We could not send OTP to your phone ${phone}|Please contact Smooci support at contact@smooci.com to verify your account and get your OTP.`;
  }

  // Handlers
  const handleSubmit = useCallback(async () => {
    const res = await login({ ...values, phone });

    if (res) {
      onSuccess?.(res.access_token);
    }
  }, [login, onSuccess, phone, values]);

  // Render
  return (
    <Form small>
      <Col1.C>
        <Callout icon="alert-outline" title={title} message={message} />
      </Col1.C>
      <Input label="OTP">
        <TextInput
          inputMode="numeric"
          name="otp"
          value={values.otp}
          onChange={setValue}
          placeholder="e.g. 1234"
        />
      </Input>
      <Button em onPress={handleSubmit} loading={isLoading}>
        Sign in
      </Button>
    </Form>
  );
}
